// Utility functions for date formatting and handling

export const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatUploadDate = (uploadedAt: string | null | undefined) => {
  if (!uploadedAt) return '';
  
  try {
    const date = new Date(uploadedAt);
    if (isNaN(date.getTime())) return '';
    
    const dateStr = date.toLocaleDateString('pt-BR');
    const timeStr = date.toLocaleTimeString('pt-BR');
    return `${dateStr} at ${timeStr}`;
  } catch (error) {
    return '';
  }
};

export const formatUploadDateShort = (uploadedAt: string | null | undefined) => {
  if (!uploadedAt) return '';
  
  try {
    const date = new Date(uploadedAt);
    if (isNaN(date.getTime())) return '';
    
    return date.toLocaleString('pt-BR');
  } catch (error) {
    return '';
  }
};

export const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    return date.toLocaleDateString('pt-BR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    return '';
  }
};
